<template>
  <ExternalList
      endpoint="/api/v2/ad-commission-agreements"
      :endpoint-filters="{user_id: user.id}"
      :headlines="headlines"
      :button-column-width="2"
      @show="edit"
      :can-destroy="() => true"
  >
    <template v-slot:default="{ row: adCommissionAgreement }">
      <td>
        {{ adCommissionAgreement.attributes.channel_name }}
      </td>

      <td>
        {{ adCommissionAgreement.attributes.portal_name }}
      </td>

      <td>
        {{ Math.round(adCommissionAgreement.attributes.commission * 100) / 100 }} %
      </td>
    </template>

    <template v-slot:modals="{ load, update }">
      <CreateModal :user="user" @created="load"/>

      <EditModal :ad-commission-agreement="editing" @updated="update"/>
    </template>
  </ExternalList>
</template>

<script>
import CreateModal from '../Modals/Create'
import EditModal from '../Modals/Edit'
import ExternalList from '../../../Panels/Lists/External'

export default {
  components: {CreateModal, EditModal, ExternalList},

  props: {
    user: {
      required: true
    }
  },

  data() {
    return {
      editing: null
    }
  },

  computed: {
    headlines() {
      return [
        {width: 8, text: 'Channel'},
        {width: 8, text: 'Portal'},
        {width: 5, text: 'Commission'}
      ]
    }
  },

  methods: {
    edit(adCommissionAgreement) {
      this.editing = adCommissionAgreement

      $('#edit-ad-commission-agreement-modal').modal('show')
    }
  }
}
</script>
